import React, { useState } from 'react';
import TableManager from '../../components/TableManager';
import useIcons from '../../assets/icons/useIcons';
import Button from '../../components/Button';
import AsideModal from '../../components/AsideModal';
import AddClaim from './AddClaim';
import { getClaims, userLogin } from '../../api';
import useUserActivation from '../../hooks/useUserActivation';
import useUserDeactivation from '../../hooks/useUserDeactivation';
import Dropdown from '../../components/Dropdown';
import { useNavigate } from 'react-router-dom';
import { DateFilterTypes, formatDate } from '../../helpers/functions';

const filterInitialValues = {
  filter: [
    {
      key: 'account_number',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter account number',
      inputType: 'number',
      inputLabel: 'Account number',
    },
    {
      key: 'carrier_email',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter carrier email',
      inputType: 'email',
      inputLabel: 'Carrier Email',
    },
    {
      key: 'carrier_phone',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter carrier phone no',
      inputType: 'number',
      inputLabel: 'Carrier phone',
    },
    {
      key: 'claim_id',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter claim id',
      inputType: 'number',
      inputLabel: 'Claim ID',
    },
  ],
};

const initialEditInstance = { isEdit: false, editData: {} };

export default function Claim() {
  const [addClaim, setaddClaim] = useState(false);
  const { mutate: activateUser } = useUserActivation();
  const { mutate: deactivateUser } = useUserDeactivation();
  const [editUserInstance, setEditUserInstance] = useState(initialEditInstance);
  const { MoreVIcon } = useIcons();
  const navigate = useNavigate();
  const handleChangeStaus = (data) => {
    if (data?.is_active) {
      deactivateUser({ uuid: data?.uuid });
    } else {
      activateUser({ uuid: data?.uuid });
    }
  };

  const handleDropListClick = async ({ value }, data) => {
    switch (value) {
      case 'edit':
        setEditUserInstance({ isEdit: true, editData: data });
        setaddClaim(true);
        break;
      case 'change-status':
        handleChangeStaus(data);
        break;
      case 'view':
        // navigate(`/user-info/${data?.uuid}/profile`);
        break;
      case 'go_to_dashboard':
        // const res = await userLogin({ uuid: data?.uuid });
        // window.open(
        //   `${process.env.REACT_APP_PORTAL_URL}login-via-admin/${res?.data?.data}`,
        // );
        break;

      default:
        break;
    }
  };

  const handleUserDetailsModal = (data) => {
    // navigate(`/user-info/${data?.uuid}/dashboard`);
    navigate(`/user-info/${data?.uuid}/profile`);
  };

  const columns = [
    {
      accessorKey: 'createdAt',
      header: () => 'Date',
      cell: (props) => formatDate(props.getValue()),
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'claimId',
      header: () => 'Claim ID',
      meta: {
        textAlign: 'center',
      },
    },
    {
      accessorKey: 'full_name',
      accessorFn: (row) =>
        `${row.carrierDetail.firstname} ${row.carrierDetail.lastname}`,
      header: () => 'Carrier Name',
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'carrier_email',
      accessorFn: (row) => `${row.carrierDetail.email}`,
      header: () => 'Carrier Email',
      meta: {
        textAlign: 'left',
      },
    },

    {
      accessorKey: 'agent_name',
      accessorFn: (row) =>
        `${row.agentDetail.firstname} ${row.agentDetail.lastname}`,
      header: () => 'Agent Name',
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'agentDetail.email',
      header: () => 'Agent Email',
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'agentDetail.phone',
      header: () => 'Agent Phone',
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'agentDetail.agentNPN',
      header: () => 'Agent NPN',
      meta: {
        textAlign: 'left',
        // width: '12%',
      },
    },
    {
      accessorKey: 'claimStatus',
      header: () => 'Status',
      meta: {
        textAlign: 'left',
      },
      cell: (props) => {
        const element = props.row.original;
        return (
          <span className="font--600">
            {element.claimStatus === 'INPROGRESS' && (
              <div className="text--secondary">In Progress</div>
            )}
            {element.claimStatus === 'ONHOLD' && (
              <div className="text--primary">On Hold</div>
            )}
            {element.claimStatus === 'SUCCESS' && (
              <div className="text--success">Success</div>
            )}
            {element.claimStatus === 'NEW' && (
              <div className="text--success">New</div>
            )}
            {element.claimStatus === 'COMPLETED' && (
              <div className="text--success">Completed</div>
            )}
          </span>
        );
      },
    },
    // {
    //   accessorKey: 'claim_status',
    //   header: () => 'Claim Status',
    //   meta: {
    //     textAlign: 'left',
    //   },
    // },

    // {
    //   accessorKey: 'created_at',
    //   header: () => 'Registration On',
    //   cell: (props) => formatDate(props.getValue()),
    //   meta: {
    //     textAlign: 'left',
    //   },
    // },
    // {
    //   accessorKey: 'action',
    //   header: () => 'Action',
    //   cell: (props) => {
    //     const element = props?.row?.original;
    //     return (
    //       <div className="gap--xs w--full d--flex align-items--center justify-content--center">
    //         <Dropdown
    //           closeOnClickOutside={true}
    //           dropList={{
    //             component: ({ item }) => (
    //               <span
    //                 className="w--full d--flex  justify-content--start p--sm"
    //                 onClick={() => handleDropListClick(item, element)}
    //               >
    //                 {item?.title}
    //               </span>
    //             ),
    //             data: [
    //               // { title: 'View', value: 'view' },
    //               // { title: 'Edit', value: 'edit' },
    //               // {
    //               //   title: `${element?.is_active ? 'Deactivate' : 'Activate'}`,
    //               //   value: 'change-status',
    //               // },
    //               // { title: 'Go to dashboard', value: 'go_to_dashboard' },
    //             ],
    //           }}
    //           showcaret={false}
    //         >
    //           <div className="w-min--32 h-min--32 d--flex align-items--center justify-content--center radius--sm bg--black-100 text--black  c--pointer">
    //             <MoreVIcon width={15} height={15} />
    //           </div>
    //         </Dropdown>
    //       </div>
    //     );
    //   },
    //   meta: {
    //     colType: 'action',
    //     textAlign: 'center',
    //     // width: '5%',
    //   },
    // },
  ];

  const tableActions = [
    {
      id: 1,
      access: true,
      component: (
        <Button
          type="button"
          btnClasses="btn w-min--150"
          variant="primary"
          color="white"
          onClick={() => setaddClaim(true)}
        >
          Add Claim
        </Button>
      ),
    },
  ];
  const handleClose = () => {
    setEditUserInstance({ isEdit: false, editData: {} });
    setaddClaim(false);
  };

  return (
    <div className="w--full">
      <TableManager
        {...{
          fetcherKey: 'getClaims',
          fetcherFn: getClaims,
          columns,
          tableActions: [],
          name: 'Claim',
          shouldFilter: true,
          initialValues: filterInitialValues,
          initialFilterState: filterInitialValues,
          selectCBForTableData: (tblData) => tblData?.data?.data?.claims,
        }}
      />
      {addClaim && (
        <AsideModal
          handleClose={handleClose}
          title="Claim"
          footerComponent={null}
        >
          <AddClaim
            editUserInstance={editUserInstance}
            handleClose={handleClose}
          />
        </AsideModal>
      )}
    </div>
  );
}
